module.exports = require("./dirPagination.js");
require("./dirPagination.tpl.html");


//////////////////
// WEBPACK FOOTER
// angularUtils-pagination (bower component)
// module id = 1469
// module chunks = 0